import React, { useEffect, useState, useCallback, useRef, useContext } from 'react';
import {
    Box,
    Button,
    Typography,
    TextField,
    Card,
    CardContent,
    CardActions,
    Divider,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BusinessIcon from '@mui/icons-material/Business';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import GavelIcon from '@mui/icons-material/Gavel';
import EmailIcon from '@mui/icons-material/Email';
import DrawerComponent from '../../common/DrawerComponent';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { BASE_URL } from '../config';
import SignatureCanvas from 'react-signature-canvas';
import { UserContext } from '../../../UserContext';


const CompanyDetails = () => {
    const [company, setCompany] = useState(null);
          const { role, user_id } = useContext(UserContext);
    const [open, setOpen] = useState(false);

    const sigCanvas = useRef(null);
    const [drawnSignature, setDrawnSignature] = useState(null);
    const fileInputRef = useRef(null);
    const getLogoSrc = () => {
        if (company?.logo?.startsWith("http"))
            return company.logo;
        if (company?.logo)
            return `${BASE_URL}${company.logo}`;
        return "";
    };

    const COMPANY_DUMMY = {
    name: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    logo: null,
    email: '',
    account_holder_name: '',
    bank_name: '',
    account_number: '',
    ifsc_code: '',
    gst_number: '',
    created_by: user_id,
    signature: null,
};
    const [formData, setFormData] = useState(COMPANY_DUMMY);

    const saveDrawnSignature = () => {
        if (!sigCanvas.current.isEmpty()) {
            setFormData({
                ...formData,
                signature: null
            })
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setDrawnSignature(sigCanvas.current.toDataURL());
        } else {
            setDrawnSignature(null);
            setFormData({
                ...formData,
                signature: null
            })
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };


    const clearSignature = () => {
        sigCanvas.current.clear();
        setDrawnSignature(null);
    };


    const fetchCompanies = async () => {
        try {
            const response = await axios.get('/api/company-details/');
            const companyData = response.data[0]; // Assuming backend returns `{ data: [ {...} ] }`
            if (companyData) {
                setCompany(companyData);
                setFormData({
                    ...companyData,
                    logo: companyData.logo,
                });
            }
        } catch (err) {
            console.error('Fetch Error:', err);
        }
    };

    useEffect(() => {
        fetchCompanies();
    }, []);

    const handleInputChange = useCallback((e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({ ...prev, [name]: e.target.value }));
    }, []);

    function dataURLToBlob(dataURL) {
        const [header, data] = dataURL.split(',');
        const mimeMatch = header.match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : 'image/png';
        const binary = atob(data);
        let length = binary.length;
        const array = new Uint8Array(length);
        while (length--) {
            array[length] = binary.charCodeAt(length);
        }
        return new Blob([array], { type: mime });
    }


    console.log(formData, "formData");

    // Submit using multipart format
    const handleSubmit = async () => {
        try {
            const formPayload = new FormData();

            Object.entries(formData).forEach(([key, value]) => {
                if (key !== 'logo' && key !== 'signature' && value !== null && value !== undefined) {
                    formPayload.append(key, value);
                }
            });

            if (formData.logo instanceof File) {
                formPayload.append('logo', formData.logo);
            }

            if (formData.signature instanceof File) {
                formPayload.append('signature', formData.signature);
            } else if (drawnSignature) {
                const blob = dataURLToBlob(drawnSignature);
                formPayload.append('signature', blob, 'signature.png');
            }

            if (company?.id) {
                await axios.put(`/api/company-details/?id=${company.id}`, formPayload, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await axios.post('/api/company-details/', formPayload, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            toast.success('Updated successfully!');
            fetchCompanies();
            setDrawnSignature(null)
            setOpen(false);

        } catch (err) {
            const backendMessage =
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err?.response?.data?.detail ||
                'Submission failed. Please try again.';
            toast.error(backendMessage);
        }
    };




    const fullAddress = `${company?.address}, ${company?.state}, ${company?.city}-${company?.pincode}`;

    return (
        <Box display="flex" justifyContent="center" alignItems="center" pt={3} px={2}>
            <Card
                sx={{
                    width: '100%',
                    maxWidth: 600,
                    backgroundColor: '#faf0e0',
                    borderRadius: 4,
                    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                    p: 2,
                    border: '2px solid #fb7102',
                }}
            >
                {/* Header */}
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{
                        background: 'linear-gradient(135deg, #faf0e0, #fff)',
                        padding: 3,
                        borderBottom: '1px solid #fb7102',
                    }}
                >
                    <Box
                        sx={{
                            width: 120,
                            height: 120,
                            mb: 2,
                            bgcolor: '#fff',
                            border: '3px solid #fb7102',
                            borderRadius: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            src={getLogoSrc()}
                            alt="Company Logo"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </Box>

                    <Typography variant="h5" fontWeight={700} color="#333">
                        {company?.name}
                    </Typography>
                </Box>

                {/* Company Info */}
                <CardContent sx={{ pb: 1 }}>
                    <Typography variant="h6" gutterBottom>
                        <BusinessIcon sx={{ mr: 1, color: '#fb7102' }} />
                        Company Info
                    </Typography>
                    <Box display="flex" flexDirection="column" gap={1.2} pl={3} mt={1} sx={{ width: '100%', maxWidth: '100%' }}>
                        <Typography><LocalPhoneIcon fontSize="small" sx={{ mr: 1 }} />{company?.phone}</Typography>
                        <Typography><EmailIcon fontSize="small" sx={{ mr: 1 }} />{company?.email}</Typography>
                        <Typography sx={{
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                        }}><LocationOnIcon fontSize="small" sx={{ mr: 1 }} />{fullAddress}</Typography>
                        <Typography><GavelIcon fontSize="small" sx={{ mr: 1 }} />GST No.: {company?.gst_number}</Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    {/* Banking */}
                    <Typography variant="h6" gutterBottom>
                        <AccountBalanceIcon sx={{ mr: 1, color: '#fb7102' }} />
                        Banking Details
                    </Typography>
                    <Box display="flex" flexDirection="column" gap={1.2} pl={3} mt={1}>
                        <Typography><AccountBalanceWalletIcon fontSize="small" sx={{ mr: 1 }} />{company?.account_holder_name}</Typography>
                        <Typography><AccountBalanceIcon fontSize="small" sx={{ mr: 1 }} />{company?.bank_name}</Typography>
                        <Typography><CreditCardIcon fontSize="small" sx={{ mr: 1 }} />Account No: {company?.account_number}</Typography>
                        <Typography><CreditCardIcon fontSize="small" sx={{ mr: 1 }} />IFSC: {company?.ifsc_code}</Typography>
                    </Box>
                </CardContent>

                <CardActions sx={{ justifyContent: 'center', mt: 2 }}>
                    <Button
                        variant="contained"
                        startIcon={<EditIcon />}
                        onClick={() => setOpen(true)}
                        sx={{
                            backgroundColor: '#fb7102',
                            color: '#fff',
                            fontWeight: 600,
                            px: 5,
                            borderRadius: 3,
                            '&:hover': {
                                backgroundColor: '#fb7102',
                            },
                        }}
                    >
                        Edit Details
                    </Button>
                </CardActions>
            </Card>

            {/* Drawer Form */}
            <DrawerComponent open={open} onClose={() => setOpen(false)} title="Edit Company Details">
                <form>
                    {[
                        { label: 'Company Name', name: 'name' },
                        { label: 'Phone', name: 'phone' },
                        { label: 'Email', name: 'email' },
                        { label: 'Address', name: 'address' },
                        { label: 'State', name: 'state' },
                        { label: 'City', name: 'city' },
                        { label: 'Pincode', name: 'pincode' },
                        { label: 'GST Number', name: 'gst_number' },
                        { label: 'Account Holder Name', name: 'account_holder_name' },
                        { label: 'Bank Name', name: 'bank_name' },
                        { label: 'Account Number', name: 'account_number' },
                        { label: 'IFSC Code', name: 'ifsc_code' },
                    ].map((field) => (
                        <TextField
                            key={field.name}
                            name={field.name}
                            label={field.label}
                            fullWidth
                            value={formData[field.name] || ''}
                            onChange={handleInputChange}
                            sx={{ marginBottom: 2 }}
                        />
                    ))}

                    {/* Logo Upload */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                            Upload Company Logo
                        </Typography>
                        <input
                            type="file"
                            name="logo"
                            accept="image/*"
                            onChange={(e) => setFormData({ ...formData, logo: e.target.files[0] })}
                        />
                        {(formData.logo && typeof formData.logo === "string") && (
                            <img
                                src={`${BASE_URL}${formData.logo}`}
                                alt="Company Logo"
                                style={{ maxWidth: 100, maxHeight: 100, border: '1px solid #ccc', borderRadius: 6 }}
                            />
                        )}
                        {(formData.logo && formData.logo instanceof File) && (
                            <img
                                src={URL.createObjectURL(formData.logo)}
                                alt="Company Logo Preview"
                                style={{ maxWidth: 100, maxHeight: 100, border: '1px solid #ccc', borderRadius: 6 }}
                            />
                        )}
                    </Box>

                    {/* Upload Signature */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                            Upload Signature
                        </Typography>
                        <input
                            type="file"
                            name="signature"
                            accept="image/*"
                            ref={fileInputRef}
                            onChange={(e) => {
                                setFormData({ ...formData, signature: e.target.files[0] })
                                clearSignature()
                            }}
                        />
                        {(formData.signature && typeof formData.signature === "string") && (
                            <img
                                src={`${BASE_URL}${formData.signature}`}
                                alt="signature"
                                style={{ maxWidth: 100, maxHeight: 100, border: '1px solid #ccc', borderRadius: 6 }}
                            />
                        )}
                        {(formData.signature && formData.signature instanceof File) && (
                            <img
                                src={URL.createObjectURL(formData.signature)}
                                alt="signature"
                                style={{ maxWidth: 100, maxHeight: 100, border: '1px solid #ccc', borderRadius: 6 }}
                            />
                        )}
                        {drawnSignature && (
                            <img
                                src={drawnSignature}
                                alt="signature"
                                style={{ maxWidth: 100, maxHeight: 100, border: '1px solid #ccc', borderRadius: 6 }}
                            />
                        )}
                    </Box>

                    {/* Draw Signature */}
                    <Box
                        sx={{
                            mb: 2,
                            p: 2,
                            border: '2px dashed #98C469',
                            borderRadius: 2,
                            backgroundColor: '#F0FFF0', // light green for contrast to form bg
                        }}
                    >
                        <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                            Draw Signature
                        </Typography>
                        <SignatureCanvas
                            penColor="black"
                            canvasProps={{
                                width: 300,
                                height: 150,
                                className: 'sigCanvas',
                                style: { backgroundColor: '#EFFCEC' },
                            }}
                            ref={sigCanvas}
                        />
                        <Box mt={1} display="flex" gap={1}>
                            <Button variant="outlined" onClick={clearSignature}>
                                Clear
                            </Button>
                            <Button variant="contained" onClick={saveDrawnSignature}>
                                Save
                            </Button>
                        </Box>
                        {/* {drawnSignature && (
                            <Box mt={1}>
                                <Typography variant="caption">Signature saved (drawn)</Typography>
                                <img src={drawnSignature} alt="Drawn signature preview" style={{ maxWidth: 200, maxHeight: 80, border: '1px solid #ccc', borderRadius: 4 }} />
                            </Box>
                        )} */}
                    </Box>

                    <Box display="flex" justifyContent="flex-end" mt={3}>
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            sx={{
                                backgroundColor: '#98C469',
                                color: '#fff',
                                fontWeight: 600,
                                '&:hover': {
                                    backgroundColor: '#85AF55',
                                },
                            }}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </DrawerComponent>
            <Toaster position="top-right" />

        </Box>
    );
};

export default CompanyDetails;
